module.exports = __webpack_public_path__ + "static/media/courses-button-1.4f1e1362.svg";